import React from 'react';
import useIntl from '@afosto/utils-react/intl/useIntl';
import usePrivate from '@afosto/auth-react/usePrivate';
import useSessionManager from '@afosto/auth-react/useSessionManager';
import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router-dom';
import Avatar from '@material-ui/core/Avatar';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Page from '@afosto/app-components-react/Page';
import Title from '@afosto/components-react/Title';
import gravatarUrl from '@afosto/utils/gravatarUrl';
import translations from './translations';
import styled from 'styled-components';

const StyledAvatar = styled(Avatar)`
  && {
    display: inline-flex;
    width: 100px;
    height: 100px;
    margin-bottom: ${props => props.theme.spacing(1)}px;
  }
`;

const Overview = () => {
  usePrivate();

  const intl = useIntl();
  const sessionManager = useSessionManager();
  const { user } = sessionManager ?? {};

  return (
    <Page title={intl.formatMessage(translations.page.title)} titleHidden>
      <Box display="flex" flexDirection="column" alignItems="center" pt={1} pb={2}>
        <StyledAvatar
          src={user && gravatarUrl(user.email, { letterValue: user.name, size: 100 })}
          alt={`Avatar image of ${user && user.name}`}
        />
        <Title
          title={intl.formatMessage(translations.page.subTitle, { fullName: user?.name ?? '' })}
        />
      </Box>
      <Grid container justify="center" spacing={2}>
        <Grid item xs={12} md={6}>
          <Card>
            <CardContent>
              <Title title={intl.formatMessage(translations.sections.activity.title)} />
              <Typography variant="body1">
                <FormattedMessage {...translations.sections.activity.description} />
              </Typography>
            </CardContent>
            <CardActions>
              <Button component={Link} to="/audit-log" variant="contained" color="primary">
                <FormattedMessage {...translations.sections.activity.button} />
              </Button>
            </CardActions>
          </Card>
        </Grid>
        <Grid item xs={12} md={6}>
          <Card>
            <CardContent>
              <Title title={intl.formatMessage(translations.sections.editProfile.title)} />
              <Typography variant="body1">
                <FormattedMessage {...translations.sections.editProfile.description} />
              </Typography>
            </CardContent>
            <CardActions>
              <Button component={Link} to="/profile" variant="contained" color="primary">
                <FormattedMessage {...translations.sections.editProfile.button} />
              </Button>
            </CardActions>
          </Card>
        </Grid>
      </Grid>
    </Page>
  );
};

export default Overview;
